import React, { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react'; // Using Lucide to match Header

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user already accepted
    const consent = localStorage.getItem('site_cookie_consent');
    if (!consent) {
      // Small delay for smooth entrance
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('site_cookie_consent', 'true');
    setIsVisible(false);
  };

  const handleDecline = () => {
    // We just close it for this session
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full bg-slate-900/95 backdrop-blur-sm text-slate-200 p-4 md:p-6 border-t border-slate-800 shadow-[0_-10px_40px_rgba(0,0,0,0.3)] animate-in slide-in-from-bottom duration-500 ease-out z-[999]">
      <div className="max-w-[1600px] mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        
        {/* Text Content */}
        <div className="flex items-start gap-5 max-w-3xl">
          <div className="bg-slate-800 p-3.5 rounded-full text-emerald-500 shrink-0 shadow-inner border border-slate-700">
            <Cookie size={28} />
          </div>
          <div>
            <h4 className="font-bold text-white text-lg mb-1 flex items-center gap-2">
              Wir verwenden Cookies
            </h4>
            <p className="text-slate-400 text-sm leading-relaxed">
              Wir nutzen Cookies, um Ihr Erlebnis auf unserer Website zu verbessern, Inhalte zu personalisieren und unseren Datenverkehr zu analysieren. Durch Klicken auf "Akzeptieren" stimmen Sie der Verwendung zu.
            </p>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex gap-3 w-full md:w-auto shrink-0">
          <button 
            onClick={handleDecline}
            className="flex-1 md:flex-none px-6 py-3 rounded-lg font-bold text-slate-400 hover:text-white hover:bg-slate-800 border border-transparent hover:border-slate-700 transition-all"
          >
            Ablehnen
          </button>
          <button 
            onClick={handleAccept}
            className="flex-1 md:flex-none px-8 py-3 rounded-lg font-bold bg-emerald-600 text-white hover:bg-emerald-700 shadow-lg shadow-emerald-900/20 hover:shadow-emerald-900/40 transition-all transform active:scale-95"
          >
            Akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;